import React from 'react';
import PropTypes from 'prop-types';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { Grid, TextField, InputAdornment } from '@material-ui/core';

export function UsernameImpl({ failedLogin }) {
  return (
    <Grid item xs={12}>
      <TextField
        required
        type="text"
        name="username"
        placeholder="jdoe"
        style={{
          width: '100%',
        }}
        label="Username"
        defaultValue={failedLogin}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
}

UsernameImpl.propTypes = {
  failedLogin: PropTypes.string.isRequired,
};

export default (UsernameImpl);
